export const getLastOfUrl = url => {
	const myarr = url.split('/')
	return myarr[0]
}
